module.exports = __webpack_public_path__ + "static/media/img-product-jeton.1be68a34.svg";